// extracted by mini-css-extract-plugin
export var columnList = "_ce-0";